var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 81,
    viewBox: "0 0 387 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26.9774C26.4515 43.267 92.1988 70.1146 159.576 47.1885C243.798 18.5309 156.557 -23.098 149.313 20.3409C142.068 63.7798 241.081 103.599 341 61.9697",
    stroke: "#217781",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.089 24.5669C383.089 24.5669 383.013 24.4398 382.962 24.389C382.911 24.3382 382.86 24.2873 382.784 24.2365C382.708 24.1857 382.631 24.1602 382.555 24.1348C382.479 24.1094 382.377 24.084 382.276 24.084C382.225 24.084 382.148 24.084 382.098 24.1094C382.021 24.1094 381.971 24.1348 381.92 24.1602L329.155 43.4006C328.773 43.5277 328.519 43.909 328.545 44.3156C328.545 44.7223 328.799 45.0782 329.206 45.2052L339.474 48.5094C339.474 48.5094 339.677 48.5602 339.779 48.5602C340.186 48.5602 340.541 48.3061 340.694 47.8994C340.846 47.3911 340.567 46.8573 340.058 46.7048L332.433 44.2394L378.539 27.4136L354.165 51.7882C353.911 52.0423 353.834 52.4236 353.936 52.754L362.12 78.1198C362.247 78.5011 362.603 78.7552 363.01 78.7807H363.035C363.416 78.7807 363.772 78.5265 363.925 78.1452L383.165 25.3802C383.165 25.3802 383.191 25.3548 383.165 25.3294C383.267 25.0498 383.216 24.7957 383.089 24.5669ZM363.086 74.8919L355.918 52.7286L379.886 28.7607L363.086 74.8919Z",
    fill: "#217781"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.886 28.7598L363.085 74.891L355.918 52.7277L379.886 28.7598Z",
    fill: "#217781"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.946 24.1348C381.946 24.1348 382.048 24.1094 382.099 24.1094C382.023 24.1094 381.972 24.1348 381.921 24.1602H381.946V24.1348Z",
    fill: "#217781"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneNews);
export default __webpack_public_path__ + "static/media/planeNews.616b68bcd1bebbc2210ec40e65c14647.svg";
export { ForwardRef as ReactComponent };